/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scl_Detail_Col_SourceInputs */

const vi_scl_detail_col_source = /** @type {(inputs: Scl_Detail_Col_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lô phân loại nguồn`)
};

/**

* @param {Scl_Detail_Col_SourceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_detail_col_source = /** @type {((inputs?: Scl_Detail_Col_SourceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_Detail_Col_SourceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_detail_col_source(inputs)
});